<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <div class="columns is-multiline" style="border: 1px solid #ededed; border-radius: 5px;">
        <div class="column is-6">
      <span
      ><label class="label">Pet: {{ deliveryCustomer.pet.name }}</label></span
      >
          <span
          ><label class="label"
          >Dono: {{ deliveryCustomer.pet.owner.name }}</label
          ></span
          >
          <span
          ><label class="label"
          >Consumo: {{ deliveryCustomer.pet.consumption }}</label
          ></span
          >
        </div>
        <div class="column is-6 pet-holder" >
          <i class="mdi mdi-window-close" @click="removePet()"></i>
        </div>
      </div>
    </div>

    <div class="column is-12">
      <button class="button is-primary" @click="addPackedProduct()">
        Adicionar receita
      </button>
      <table class="table is-fullwidth" v-if="deliveryCustomer.deliveryProducts.length">
        <thead>
          <tr>
            <th>Receita</th>
            <th>Batch</th>
            <th>Tamanho</th>
            <th>Quantidade</th>
            <th>Opções</th>
          </tr>
        </thead>
        <tbody>
          <delivery-product-component
            v-for="deliveryProduct in deliveryCustomer.deliveryProducts"
            :item="deliveryProduct"
            :key="deliveryProduct.id"
            @removeProduct="removeProduct"
          >
          </delivery-product-component>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DeliveryProductComponent from "./DeliveryProductComponent";

export default {
  name: "DeliveryCustomerComponent",
  components: { DeliveryProductComponent },
  props: ["item"],
  data: function() {
    return {
      deliveryCustomer: this.item,
      isFetching: false,
      receiptList: [],
      receiptSearchText: "",
      selectedReceipt: {}
    };
  },
  methods: {
    removeProduct(option) {
      this.deliveryCustomer.deliveryProducts = this.deliveryCustomer.deliveryProducts.filter(
        dp => {
          return dp.packedProduct.id !== option.packedProduct.id;
        }
      );
    },
    addPackedProduct() {
      this.deliveryCustomer.deliveryProducts.push({
        id: new Date().getTime(),
        packedProduct: {},
        quantity: 0,
        newPackedProduct: true
      });
    },
    removePet() {
      this.$emit("removePet");
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>

  .pet-holder{
    align-items: center;
    justify-content: flex-end;
    display: flex;
    i{cursor:pointer}
  }
</style>
